import React from 'react';
import { Paper, CssBaseline } from '@material-ui/core';
import { useStyle } from './styles';

export default function Layout(props) {
  const { children } = props;
  const classes = useStyle();

  return (
    <>
      <CssBaseline />
      <div className={classes.root}>
        <Paper className={classes.paper}>{children}</Paper>
      </div>
    </>
  );
}
